<template>
    <div class="d-lg-block" :class="{ 'd-none': hasActiveConversation, 'd-block': !hasActiveConversation}">
        <div class="card mx-3 mt-2 mt-lg-0 mb-lg-2 mb-0" v-show="isLoading">
            <div class="card-body">
                <div class="text-center py-3">
                    <span class="spinner-border" role="status"></span>
                </div>
            </div>
        </div>
        <ConversationListItem v-for="conversation in conversations" :conversation="conversation" :key="conversation.id"></ConversationListItem>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/chatStore';
import ConversationListItem from './ConversationListItem.vue';

const conversations = computed(() => Store.getConversations());
const isLoading = computed(() => Store.isLoading());
const hasActiveConversation = computed(() => Store.getActiveConversation() !== null);

Store.init();
</script>